import { ApprovalRange } from '../../../../../core';

const iconsOfActionsList = [
  {
    icon: 'edit',
    tooltip: 'Editar',
    hasVisibleCondition: (element: ApprovalRange[]): boolean => element.length === 1
  },
  {
    icon: 'trash',
    tooltip: 'Eliminar',
    hasVisibleCondition: (element: ApprovalRange[]): boolean => true
  }
];

export const approvalRange = {
  searchText: 'Buscar rango',
  addText: 'Rango',
  export: false,
  dialogHability: true,
  filter: false,
  paginator: false,
  checkbox: true,
  checkboxHeader: false,
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: ApprovalRange, selection: ApprovalRange[]) => {
    if (selection.length > 0 && row) {
      return selection.length === 1 && row.hierarchyCode === selection[0].hierarchyCode ? false : true;
    } else {
      return false;
    }
  },
  columns: [
    {
      title: 'Jerarquía',
      name: 'hierarchyBreadcrumb',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: ApprovalRange) => element.hierarchyBreadcrumb
    },
    {
      title: 'Rangos de margen',
      name: 'margin',
      type: 'array',
      editable: false,
      checkAll: false,
      listing: true,
      class: 'left',
      value: (element: ApprovalRange) => [element.marginConfig, 'margin']
    },
    {
      title: 'Niveles de aprobación',
      name: 'level',
      type: 'array',
      editable: false,
      checkAll: false,
      listing: true,
      class: 'left',
      value: (element: ApprovalRange) => [element.marginConfig, 'level']
    }
  ]
};
